import {
  type ChangeEventHandler,
  type ComponentProps,
  type FocusEventHandler,
  useRef,
} from 'react';
import {type UseFormRegisterReturn} from 'react-hook-form';

type Props = ComponentProps<'textarea'> & {
  readonly register: UseFormRegisterReturn;
};

/**
 * このコンポーネントはテストメール送信フォームに深く依存しているため再利用不可
 */
export function MailTitleTextarea({
  register: {ref, onChange, onBlur, ...rest},
  ...props
}: Props) {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const adjustTextareaHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = '0';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  const refCallback = (element: HTMLTextAreaElement | null) => {
    ref(element);
    textareaRef.current = element;
    adjustTextareaHeight();
  };

  const handleChange: ChangeEventHandler<HTMLTextAreaElement> = (event) => {
    if (textareaRef.current === null) return;

    textareaRef.current.value = textareaRef.current.value.replaceAll(
      /\r|\n/g,
      '',
    );
    adjustTextareaHeight();
    onChange(event);
  };

  const handleBlur: FocusEventHandler<HTMLTextAreaElement> = (event) => {
    if (textareaRef.current === null) return;

    textareaRef.current.value = textareaRef.current.value.trim();
    onBlur(event);
  };

  return (
    <textarea
      {...props}
      {...rest}
      ref={refCallback}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
}
